import { useNavigate } from 'react-router-dom';
import ModalWindow from '../../../ui/modal-window/ModalWindow';
import { ReactComponent as CheckMarkIcon } from '../../../../assets/images/icons/check-mark-icon.svg';
import { Routes } from '../../../../router/routes';
import styles from '../registration.module.sass';
import Btn_transparent from '../../../ui/btn_transparent/Btn_transparent';
import { useTranslation } from 'react-i18next';

type RegistrationMessageProps = {
  isActive: boolean;
  setActive: (modalIsActive: boolean) => void;
};

const RegistrationMessage = ({
  isActive,
  setActive,
}: RegistrationMessageProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClickHandler = () => {
    setActive(false);
    navigate(Routes.Login);
  };
  return (
    <ModalWindow isActive={isActive} setActive={onClickHandler}>
      <div className={styles.successMessage}>
        <div>{t('additionalPages.accountConfirmationEmailSent')}</div>
        <CheckMarkIcon width="60" height="60" />
        <Btn_transparent
          className={styles.btnSucess}
          variant="standart"
          onClick={onClickHandler}
        >
          {t('additionalPages.continue')}
        </Btn_transparent>
      </div>
    </ModalWindow>
  );
};
export default RegistrationMessage;
